<template>
    <div class="mb-2">
        <Table :columns="columns" :data="records" size="small" max-height="700" />
    </div>
</template>

<script>
export default {
    props: {
        records: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t('feePredefineItem.feeType'),
                    key: 'fee_type_name'
                },
                {
                    title: this.$t('feePredefineItem.feeName'),
                    key: 'fee_name_en'
                },
                {
                    title: this.$t('feePredefineItem.descrtiption'),
                    key: 'fee_name_en'
                },
                {
                    title: this.$t('feePredefineItem.qty'),
                    key: 'quantity',
                    align: 'center'

                }
            ]
        }
    }
}
</script>
